// extracted by mini-css-extract-plugin
export var fullWidthButton = "_on-0";